<template>
  <v-layout row>
    <v-flex xs12 md6>
      <v-layout>
        <v-flex xs12 class="form-subtitle">
          ご連絡先
          <span class="attention">(必須)</span>
        </v-flex>
      </v-layout>

      <!-- 国番号 + 電話番号入力 -->
      <v-layout row>
        <!-- 国番号のドロップダウン -->
        <v-flex xs3 class="col-tel">
          <phone-country-select
            :phone-country-codes="phoneCountryCodes"
            :default-phone-country-code="phoneCountryCode"
          />
        </v-flex>

        <!-- 電話番号入力 -->
        <v-flex
          xs3
          class="col-tel"
          v-for="(tel, index) in telNumbers"
          :key="index"
        >
          <v-text-field
            v-model="telNumbers[index]"
            :name="`tel1_${index + 1}`"
            type="text"
            class="tel"
            required
            maxlength="4"
            :error-messages="errorMessages[`tel1_${index + 1}`] || ''"
          ></v-text-field>
          <span v-if="index < 2" class="tel-hyphen">-</span>
        </v-flex>
      </v-layout>

      <!-- メールアドレス入力 -->
      <v-layout row>
        <v-flex xs12 md12>
          <v-text-field
            v-model="email"
            name="email"
            type="email"
            label="メールアドレス*"
            required
            :error-messages="errorMessages.email || ''"
          ></v-text-field>
        </v-flex>
      </v-layout>

      <v-layout row>
        <v-flex xs12>
          <p class="attention">
            ※お申込み完了後、ご案内のメールを送信しております。お間違えのないようご注意ください。
          </p>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import PhoneCountrySelect from "./PhoneCountrySelect.vue";

export default {
  components: {
    PhoneCountrySelect,
  },
  props: {
    phoneCountryCodes: Object,
    defaultPhoneCountryCode: String,
    defaultTel1_1: String,
    defaultTel1_2: String,
    defaultTel1_3: String,
    defaultEmail: String,
    errorMessages: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      phoneCountryCode: this.defaultPhoneCountryCode || "81",
      telNumbers: [
        this.defaultTel1_1 || "",
        this.defaultTel1_2 || "",
        this.defaultTel1_3 || "",
      ],
      email: this.defaultEmail || "",
    };
  },
};
</script>

<style scoped>
.attention {
  color: #e4442f;
  font-size: 1rem;
}
.tel-hyphen {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 5px;
}
</style>
